module.exports = "/images/lines-4.jpg";